import {DataBaseComponent, DataBaseComponentState, Errors} from "./DataBaseComponent";

export default DataBaseComponent;

export {DataBaseComponent, DataBaseComponentState, Errors};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/DataBaseComponent/index.ts